import { render, staticRenderFns } from "./responsiveheader.html?vue&type=template&id=7b80008a&scoped=true&"
import script from "./responsiveheader.js?vue&type=script&lang=js&"
export * from "./responsiveheader.js?vue&type=script&lang=js&"
import style0 from "./responsiveheader.scss?vue&type=style&index=0&id=7b80008a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80008a",
  null
  
)

export default component.exports